import { useQuery, useMutation } from "react-query";
import { getUsers, addUser, findUser, editUser, deleteUser, changePasswordUser, importUser } from "../apiClient/users";
import { queryClient } from "../../libs/react-query";
import { GET_USER, FIND_USER } from "../../constants/queryKeys";

const invalidateUserQuery = () => {
	queryClient.invalidateQueries(GET_USER);
};

const useGetUsers = ({ payload, config }) => {
	return useQuery([GET_USER, payload], () => getUsers(payload), config);
};
const useFindUser = ({ payload, config }) => {
	return useQuery([FIND_USER, payload], () => findUser(payload), config);
};
const useAddUser = (options) => {
	return useMutation((payload) => addUser(payload), options);
};
const useEditUser = (options) => {
	return useMutation((payload) => editUser(payload), options);
};
const useDeleteUser = (options) => {
	return useMutation((payload) => deleteUser(payload), options);
};
const useChangePasswordeUser = (options) => {
	return useMutation((payload) => changePasswordUser(payload), options);
};
const useImportUser = (options) => {
	return useMutation((payload) => importUser(payload), options);
};


export { useGetUsers, useAddUser, useEditUser, useDeleteUser, useFindUser, useChangePasswordeUser, invalidateUserQuery, useImportUser };
